import PessoaHipertensaoIcon from '@/components/icons/IndicadoresAps/eSFeAP/PessoaHipertensao.vue'

export default {
  value: 'c5',
  label: 'Pessoa hipertensa',
  iconType: 'component',
  iconComponent: PessoaHipertensaoIcon,
  buscaAtiva: {
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a avaliação de hipertensão (em atraso).'
        : 'Realizar e registrar a avaliação de hipertensão (em atraso).',
    b: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar a pressão arterial (em atraso).'
        : 'Aferir e registrar a pressão arterial (em atraso).',
    c: 'Acionar o Agente de Saúde para visita domiciliar (em atraso).',
    d: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar peso e altura (em atraso).'
        : 'Aferir e registrar peso e altura (em atraso).',
  },
}
